import { attachFlashcardSpeech } from '../tenant/flashcard_speech'
import AudioPlayerService from '../account/chat/audio_player_service'
import { secondaryAudioVoiceOptions } from '../utils/secondaryAudioVoice'

let tenantSpeechCleanup;
document.addEventListener("turbolinks:load", function () {
  tenantSpeechCleanup?.();
  if (document.querySelector('meta[name="server-mediated-ai"]')?.content === 'true') {
    tenantSpeechCleanup = attachFlashcardSpeech(document.querySelector('[data-cartus-flashcard]'));
    return;
  }
  if (document.getElementById('flashcard_front_word')) {
    const flashcardWordElement = document.getElementById('flashcard_front_word');
    const currentWord = flashcardWordElement && flashcardWordElement.dataset.audioWord;
    const flashcardLanguageElement = document.getElementById('flashcard_word_language');
    const language = flashcardLanguageElement && flashcardLanguageElement.dataset.language;
    // Japanese flashcard audio follows the selected voice (LAN-326); other
    // languages keep the historical ElevenLabs behaviour.
    const ttsOptions = secondaryAudioVoiceOptions({
      language,
      voice: flashcardLanguageElement && flashcardLanguageElement.dataset.voice,
      keepRotation: true
    });
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    // Initialize AudioPlayerService like suggested text does
    const audioPlayerService = new AudioPlayerService(csrfToken);

    $('body').on('click', '.js-play-audio-btn', function (e) {
      e.preventDefault();

      const audioBtn = this;

      // Use the same pattern as guided mode service
      if (audioPlayerService.soundPlaying && audioPlayerService.soundEl === audioBtn) {
        audioPlayerService.togglePlayer();
      } else {
        // Show loading state
        audioBtn.classList.add('pulse');

        // Use the same fetchAudioData method as suggested text
        audioPlayerService.fetchAudioData(currentWord, language, ttsOptions).then(data => {
          audioBtn.classList.remove('pulse');

          // Play the audio using the same setup as suggested text
          audioPlayerService.setupPlayer(data.audioUrl, audioBtn, data.playbackRate || 1.0);
          audioPlayerService.player.play();
        }).catch(error => {
          console.error('Error fetching flashcard audio:', error);
          audioBtn.classList.remove('pulse');
        });
      }
    });
  }
});
